import * as React from 'react'
import { Route, RouteComponentProps, Switch } from 'react-router'
import { ICreateDriver, IStateDriver, IStepsCreateDriver } from '../../types'
import OperatorInfoForm from './OperatorInfoForm'
import EditDriverProducts from '../../containers/drivers/EditDriverProducts'
import ErrorMessage from '../ui/ErrorMessage'
import StepBar from '../ui/entity/EntityStepBarV2'
import UIMessages from '../../utils/ui-messages'

interface ICreateDriverProps {
  addDriverInfo: (data: ICreateDriver) => Promise<IStateDriver>
  handleNext: () => void
  handlePrev: () => void
  stepsCreateDriver: IStepsCreateDriver[]
  processing: boolean
  processingError: string
  history: any
  location: any
  loading: boolean
  match: any
  organizationId: string
}

export interface ICreateDriverState {}

class CreateDriver extends React.Component<ICreateDriverProps, ICreateDriverState> {
  private steps = [
    {
      name: 'Personal Info',
      toFind: (pathname: string): boolean => pathname === '/drivers/create'
    },
    {
      name: 'Products',
      toFind: (pathname: string): boolean => pathname.includes('add-products')
    }
  ]

  public render() {
    return (
      <div className='flex flex-wrap items-start'>
        <StepBar steps={this.steps} pathname={this.props.location.pathname} title='Create New Driver' />
        <ErrorMessage visible={!!this.props.processingError}>{this.props.processingError}</ErrorMessage>
        <Switch>
          <Route path={this.props.match.path} exact={true} render={this.renderForm} />
          <Route
            path={`${this.props.match.path}/:id/add-products`}
            exact={true}
            component={EditDriverProductsWrapper}
          />
        </Switch>
      </div>
    )
  }

  private handleSubmit = (data: ICreateDriver) => {
    data.organizationId = this.props.organizationId
    return this.props.addDriverInfo(data)
  }

  private renderForm = () => (
    <OperatorInfoForm
      handleSubmit={this.handleSubmit}
      history={this.props.history}
      match={this.props.match}
      loading={this.props.loading}
      submitBtnText={UIMessages.common.create}
    />
  )
}

const EditDriverProductsWrapper = (props: RouteComponentProps<any>) => (
  <div className='w100'>
    <EditDriverProducts {...props} submitBtnText={UIMessages.common.create} nextLink='/drivers' />
  </div>
)

export default CreateDriver



// WEBPACK FOOTER //
// ./src/components/drivers/CreateDriver.tsx